import { SitesetupConfiguration } from './../config/sitesetup_configuration';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import { IProgression } from 'utility-js-progression';

angular
  .module('capability-ng-sitesetup')
  .factory(
    'loadConfigCommand',
    (
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngSitesetupConfiguration: SitesetupConfiguration,
      ngTransferCreditsProgression: IProgression
    ): ICommand => {
      return defineCommand('loadConfigCommand', (deferred: ng.IDeferred<IQuery[]>): ng.IPromise<void> => {
        return $http({
          method: 'GET',
          url: ngSitesetupConfiguration.capability.configUrl
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            ngSitesetupConfiguration.setupConfig(response.data.results);
            if (!ngSitesetupConfiguration.isAdditionalCourseInfoEnabled) {
              // TODO Update progression utility to include remove method for removing a state and update the ordering
              ngTransferCreditsProgression.source.refine = undefined;
              (ngTransferCreditsProgression as any)._ordering = ['major', 'past', 'exam', 'summary'];
            }
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/sitesetup/commands/load_config_command.ts